import { Resource } from "@domain/base/Resource";
import { IWarehouseRepository } from "@domain/inventory/IWarehouseRepository";
import { Warehouse } from "@domain/inventory/models/Warehouse";
import { WarehouseConnection } from "@domain/inventory/models/WarehouseConnection";
import { WarehouseDataSource } from "../datasources/WarehouseDataSource";

export class WarehouseRepository implements IWarehouseRepository {
  constructor(private dataSource: WarehouseDataSource) { }

  async getWarehouses(): Promise<Resource<Warehouse[]>> {
    try {
      const data = await this.dataSource.getWarehouses();
      return { status: 'success', data };
    } catch (error) {
      return {
        status: 'error',
        error: {
          type: 'UnknownError',
          message: 'Failed to fetch warehouses'
        }
      };
    }
  }

  async getWarehouse(id: string): Promise<Resource<Warehouse>> {
    try {
      const data = await this.dataSource.getWarehouse(id);
      return { status: 'success', data };
    } catch (error) {
      return {
        status: 'error',
        error: {
          type: 'UnknownError',
          message: 'Failed to fetch warehouse'
        }
      };
    }
  }

  async createWarehouse(name: string, location?: string, warehouseConnections?: Omit<WarehouseConnection, 'id'>[]): Promise<Resource<Warehouse>> {
    try {
      const data = await this.dataSource.createWarehouse(name, location, warehouseConnections);
      return { status: 'success', data };
    } catch (error) {
      return {
        status: 'error',
        error: {
          type: 'UnknownError',
          message: 'Failed to create warehouse'
        }
      };
    }
  }

  async deleteWarehouse(id: string, options: { deleteConnections: boolean; deleteMutations: boolean }): Promise<Resource<void>> {
    try {
      await this.dataSource.deleteWarehouse(id, options);
      return { status: 'success', data: undefined };
    } catch (error) {
      return {
        status: 'error',
        error: {
          type: 'UnknownError',
          message: 'Failed to delete warehouse'
        }
      };
    }
  }
}